var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSyncwithProgress(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "syncwith_progress",
    transform: "translate(-973 -186)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "syncprogress_icn"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1975",
    "data-name": "Ellipse 1975",
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(973 186)",
    fill: "#2769ff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "vuesax_linear_refresh-2",
    "data-name": "vuesax/linear/refresh-2",
    transform: "translate(975.875 188.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "refresh-2",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.11,14.44v2.136",
    transform: "translate(0.218 -7.418)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-2",
    "data-name": "Vector",
    d: "M8.542,4.271A4.273,4.273,0,0,1,4.271,8.542c-2.358,0-3.8-2.375-3.8-2.375H2.4M0,4.271A4.262,4.262,0,0,1,4.271,0,5.254,5.254,0,0,1,8.542,2.375m0,0V.239m0,2.136h-1.9",
    transform: "translate(0.854 0.854)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector-3",
    "data-name": "Vector",
    d: "M0,0H10.25V10.25H0Z",
    transform: "translate(10.25 10.25) rotate(180)",
    fill: "none",
    opacity: 0
  })))), /*#__PURE__*/React.createElement("line", {
    id: "Line_1170",
    "data-name": "Line 1170",
    x2: 15,
    transform: "translate(973.5 206.5)",
    fill: "none",
    stroke: "#d8e0eb",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1171",
    "data-name": "Line 1171",
    x2: 8,
    transform: "translate(973.5 206.5)",
    fill: "none",
    stroke: "#ff5757",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSyncwithProgress);
export default __webpack_public_path__ + "static/media/syncwith_progress.e816bfe01d5a38ff22e67db7a0f87658.svg";
export { ForwardRef as ReactComponent };